import { Localization, Months, WeekDays } from "../types/types";

interface DateStrings {
  WEEKDAYS: Record<string, string>;
  MONTHS: Record<string, string>;
}

export interface MatchDateParts {
  dateTime: string;
  weekday: string;
  date: string;
  time: string;
}

export const formatMatchDate = (
  isoDate: string,
  locale: Localization,
  strings: DateStrings,
): MatchDateParts | null => {
  if (!Date.parse(isoDate)) {
    return null;
  }

  const date = new Date(isoDate);
  const dayKey = WeekDays[date.getDay()];
  const monthKey = Months[date.getMonth()];
  const weekday = strings.WEEKDAYS[dayKey];
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");

  if (locale === Localization.Finnish) {
    return {
      dateTime: isoDate,
      weekday,
      date: `${String(day)}.${String(month)}.${String(year)}`,
      time: `klo ${hours.toString().padStart(2, "0")}:${minutes}`,
    };
  }

  const period = hours >= 12 ? "PM" : "AM";
  const hour12 = (hours % 12 || 12).toString();
  const monthLabel = strings.MONTHS[monthKey].substring(0, 3);

  return {
    dateTime: isoDate,
    weekday,
    date: `${monthLabel} ${String(day)}, ${String(year)}`,
    time: `${hour12}:${minutes} ${period}`,
  };
};
